import { DateTime } from 'luxon';
import { timeZone, createDateTimePrinter } from './utils.mjs';


function processTalkData(rawTalks, socials) {
  const headshotPrefix = '/images/speakers';

  const validateTalk = function(talk) {
    const required = ['id', 'speakers'];

    for(const key of required) {
      if (talk[key] === undefined) {
        console.warn('Skipping talk', talk);
        console.warn(`Missing mandatory field "${key}"`);
        return;
      }
    }

    if (talk.abstract) {
      talk.abstract = `/abstracts/${talk.id}.html`;
    }

    return true;
  };

  const validateSpeaker = function(speaker) {
    const required = ['id', 'alpha', 'name'];

    for(const key of required) {
      if (speaker[key] === undefined) {
        console.warn('Skipping speaker', speaker);
        console.warn(`Missing mandatory field "${key}"`);
        return;
      }
    }

    if (speaker.social) {
      speaker.social = speaker.social
        .filter(function({ id }) {
          if (id in socials) { return true; }
          const generic = 'Removing unrecognised social media platform';
          const detail = `"${id}" for speaker "${speaker.name}"`;
          console.warn(`${generic} ${detail}`);
        })
        
      speaker.social.forEach(d => Object.assign(d, socials[d.id]));
    }

    if (speaker.img) {
      const start = `${headshotPrefix}/${speaker.id}`;
      speaker.img = {
        src: `${start}.jpg`,
        srcset: `${start}@2x.jpg 2x`,
        alt: `${speaker.name} headshot`
      };
    }
    else {
      const start = '/images/empty-profile';
      speaker.img = {
        src: `${start}.png`,
        srcset: `${start}@2x.png 2x`,
        alt: '',
        placeholder: true
      };
    }

    return true;
  }


  const filteredTalks = rawTalks.filter(validateTalk);

  filteredTalks.forEach(function(talk) {
    talk.speakers = talk.speakers.filter(validateSpeaker);
    talk.speakers.forEach(s => s.talkId = talk.id);
  });

  return new Map(filteredTalks.map(d => [d.id, d]));
}


function processTimetableData(dates, rawTimetable) {
  const date = dates.talks.date;
  const t0 = dates.talks.times.default;
  const timestamp0 = DateTime.fromISO(`${date}T${t0}`, { zone: timeZone });
  const timePrinter = createDateTimePrinter('T');

  const getTime = function(offsetMins = 0) {
    const timestamp = timestamp0 + (offsetMins * 60 * 1000);
    return timePrinter(timestamp);
  };
  
  let offset = 0;

  const addStartEnd = function(d) {
    const { duration } = d;
    d.startTime = getTime(offset);
    offset += duration;
    d.endTime = getTime(offset);
  };

  return rawTimetable.map(d => (addStartEnd(d), d));
}


function mergeInTimetableData(talks, timetable) {
  timetable
    .filter(d => d.talkId)
    .forEach(function(d) {
      const talk = talks.get(d.talkId);
      if (talk) { talk.slot = d; }
    });
}


function processData(dates, rawTalks, rawTimetable, socials) {
  const talks = processTalkData(rawTalks, socials);
  const timetable = processTimetableData(dates, rawTimetable);
  mergeInTimetableData(talks, timetable);
  return { talks, timetable };
}


export { processData };
